import React, { Fragment } from 'react';
import { createRoot } from 'react-dom/client';

import Apps from './components/Apps';
import HeatMap from './components/HeatMap';
import TopApps from './components/TopApps';
import TopTrends from './components/TopTrends';
import MiniHeader from '../_shared/components/MiniHeader';
import SectionDivider from '../_shared/components/SectionDivider';
import AdditionalResources from '../_shared/components/AdditionalResources';
import useMobileView from '../../alchemy/сompetitive-intelligence-reports/shared/hooks/useMobileView';
import Container from '../../../components/Container';

import { rootNode, initParams } from './configs';

const { data } = initParams;

const FinanceSectors = () => {
  const isMobileView = useMobileView();

  return (
    <Fragment>
      <MiniHeader isMobileView={isMobileView} date={data.published_date} />
      <Apps
        header={data.header}
        subheader={data.subheader}
        apps={data.apps}
        isMobileView={isMobileView}
      />
      <SectionDivider />
      <HeatMap data={data.heatmap_chart} />
      <TopTrends
        trends={data.top_trends}
        isMobileView={isMobileView}
      />
      <div className="sector-additional-info">
        <Container maxWidth={1248}>
          <TopApps
            data={data.top_apps}
            isMobileView={isMobileView}
          />
          <SectionDivider disableGutters />
          <AdditionalResources resources={data.additional_resources} />
        </Container>
      </div>
    </Fragment>
  );
};

document.addEventListener('DOMContentLoaded', () => {
  const root = createRoot(rootNode);
  root.render(<FinanceSectors />);
});
